"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = function _default() {
  let prefix = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return [_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 9.7563c0-.8494.251-1.7028.908-2.3395C5.562 6.783 6.478 6.5 7.5324 6.5c.9997 0 1.8874.2954 2.5308.9141.6456.6208.9367 1.4635.9367 2.3422 0 .8875-.3034 1.7271-.9521 2.3413-.6446.6102-1.5286.9024-2.5154.9024-.9858 0-1.8774-.2911-2.534-.8895C4.3343 11.5052 4 10.6652 4 9.7563zM7.5325 8.5c-.7118 0-1.062.1875-1.2326.353C6.132 9.0155 6 9.2903 6 9.7562c0 .4063.1397.6883.3457.876.2135.1946.588.3677 1.1868.3677.5975 0 .9473-.172 1.1404-.3548.189-.1789.3271-.4611.3271-.889 0-.4366-.1374-.722-.323-.9005C8.4892 8.675 8.143 8.5 7.5325 8.5z"
  }), _react.default.createElement("path", {
    d: "m13.8667 14.226-2.168 1.7739L22 16v-2h-4.7447c.6894-.5868 1.4397-1.2375 2.0652-1.8088.5147-.47 1.0375-1.2866.63-2.1649C19.5731 9.2126 18.6758 9 18.0005 9H12v2h5.6561c-.7411.6645-1.613 1.4093-2.3376 2.019a169.6596 169.6596 0 0 1-1.3423 1.1172l-.1095.0898z"
  }), _react.default.createElement("path", {
    d: "M4 14v2c0 1.1046.8954 2 2 2h16v2H6c-2.2091 0-4-1.7909-4-4v-2h2z"
  })];
};

exports.default = _default;